import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch } from "react-router-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import Provider from "react-redux/es/components/Provider";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import "bootstrap";

// Import Main styles for this application
import "./scss/style.scss";
import "./scss/core/_dropdown-menu-right.scss";
import "../../scss/style.scss";
// Import Dashboard CSS

// Containers
import Navigation from "./containers/Navigation";
import { middleware, reducers } from "./store";
import Admins from "./views/Admins";
import Login from "./views/Login";
import Customers from "./views/Customers";
import CustomerDetail from "./views/CustomerDetail";
import Dashboard from "./views/Dashboard";
import Posts from "./views/Posts";
import PostDetail from "./views/PostDetail";
import TripPlans from "./views/TripPlans";
import TripDetail from "./views/TripDetail";
import Transactions from "./views/Transactions";
import TransactionDetail from "./views/TransactionDetail";
import Report from "./views/Report";
import Setting from "./views/Setting";
import StripeOnboard from "./views/StripeOnboard";

import { paths } from "../../../common/constants";
import AdminDetail from "./views/AdminDetail";
import PushNotification from "./views/PushNotification";

const store = createStore(reducers, applyMiddleware(thunk, middleware()));

ReactDOM.render(
  <Provider store={store}>
    <Router history={createBrowserHistory()}>
      <Switch>
        <Route exact path={paths.client.ADMIN_LOGIN} component={Login} />
        <Route
          exact
          path={paths.client.APP_STRIPE_ONBOARD}
          component={StripeOnboard}
        />
        <Navigation>
          <Switch>
            <Route
              exact
              path={paths.client.ADMIN_DASHBOARD}
              component={Dashboard}
            />
            <Route exact path={paths.client.ADMIN_ADMINS} component={Admins} />
            <Route
              exact
              path={paths.client.ADMIN_ADMINS_ADD}
              component={AdminDetail}
            />
            <Route
              exact
              path={paths.client.ADMIN_CUSTOMERS}
              component={Customers}
            />
            <Route
              exact
              path={paths.client.ADMIN_CUSTOMER_DETAIL}
              component={CustomerDetail}
            />
            <Route exact path={paths.client.ADMIN_POSTS} component={Posts} />
            <Route
              exact
              path={paths.client.ADMIN_POST_DETAIL}
              component={PostDetail}
            />
            <Route
              exact
              path={paths.client.ADMIN_TRIP_PLANS_UPCOMING}
              component={TripPlans}
            />
            <Route
              exact
              path={paths.client.ADMIN_TRIP_PLANS_PAST}
              component={TripPlans}
            />
            <Route
              exact
              path={paths.client.ADMIN_TRIP_PLAN_UPCOMING_DETAIL}
              component={TripDetail}
            />
            <Route
              exact
              path={paths.client.ADMIN_TRIP_PLANS_PAST_DETAIL}
              component={TripDetail}
            />
            <Route
              exact
              path={paths.client.ADMIN_TRANSACTIONS}
              component={Transactions}
            />
            <Route
              exact
              path={paths.client.ADMIN_TRANSACTION_DETAIL}
              component={TransactionDetail}
            />
            <Route exact path={paths.client.ADMIN_REPORT} component={Report} />
            <Route
              exact
              path={paths.client.ADMIN_SETTING}
              component={Setting}
            />
            <Route
              exact
              path={paths.client.ADMIN_PUSH_NOTIFICATION}
              component={PushNotification}
            />
          </Switch>
        </Navigation>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./client/react/Admin/index.js